import { FETCH_OPTIONS, STRUTTURE_ENDPOINTS } from '../config/constants';
import { Struttura } from '../models/models';

/**
 * Carica le strutture dall'API
 * Ordinate alfabeticamente per nome_struttura
 */
export const fetchStrutture = async (): Promise<Struttura[]> => {
  const res = await fetch(STRUTTURE_ENDPOINTS.GET_STRUTTURE, FETCH_OPTIONS);
  if (!res.ok) {
    throw new Error('Errore nel caricamento delle strutture');
  }
  
  const data = await res.json();
  const strutture = Array.isArray(data) ? data : data.strutture || [];
  
  // Ordina alfabeticamente per nome_struttura
  return strutture.sort((a: Struttura, b: Struttura) =>
    a.nome_struttura.localeCompare(b.nome_struttura)
  );
};
